/** Pipeline debug sandbox input limits (code constants — not env-configured). */

export const PIPELINE_DEBUG_MAX_INPUT_BYTES = 2 * 1024 * 1024;

export const PIPELINE_DEBUG_MAX_LIN_LOGS = 100;

export const PIPELINE_DEBUG_MAX_LOG_BATCHES = 100;

export const PIPELINE_DEBUG_MAX_ANOMALY_EVENTS = 500;

export const PIPELINE_DEBUG_MAX_DE_EVENTS = 200;

export type PipelineStepInputValidationLimits = {
  maxInputBytes: number;
  maxLinLogs: number;
  maxLogBatches: number;
  maxAnomalyEvents: number;
  maxDeEvents: number;
};

export const PIPELINE_DEBUG_STEP_INPUT_LIMITS: PipelineStepInputValidationLimits =
  {
    maxInputBytes: PIPELINE_DEBUG_MAX_INPUT_BYTES,
    maxLinLogs: PIPELINE_DEBUG_MAX_LIN_LOGS,
    maxLogBatches: PIPELINE_DEBUG_MAX_LOG_BATCHES,
    maxAnomalyEvents: PIPELINE_DEBUG_MAX_ANOMALY_EVENTS,
    maxDeEvents: PIPELINE_DEBUG_MAX_DE_EVENTS,
  };
